module.exports = __webpack_public_path__ + "static/media/footer-web.e19d217a.png";